import { render, staticRenderFns } from "./VenueStores.vue?vue&type=template&id=0c0f4fe8"
import script from "./VenueStores.vue?vue&type=script&lang=ts"
export * from "./VenueStores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports